import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../services/redux/store';
import { Image } from '../../../components/Image';
import { STYLE_VARS } from '../../../constants/style-vars';
import { COLORS, FONTS } from '../../../constants';
import { NavigationService } from '../../../services/navigation';
import { IS_WEB, getWidth } from '../../../constants/platform';
import { addBase64Prefix } from '../../../services/addBase64Prefix';
import { close_icon } from '../../../assets/base64';

const UserMenu: FC = () => {
  const { info } = useSelector((redux: RootState) => redux.authReducer);
  const width = getWidth();
  return (
    <View style={styles.wrapper}>
      <TouchableOpacity
        onPress={() => {
          NavigationService.push('Root', {
            screen: 'MyAccountTab',
          });
        }}
        style={{
          borderRadius: 120,
          width: 120,
          height: 120,
          marginRight: 20,
        }}
      >
        <Image
          source={
            info?.avatar
              ? { uri: info?.avatar }
              : require('../../../assets/avatar.png')
          }
          style={{
            borderRadius: 120,
            width: 120,
            height: 120,
            resizeMode: 'cover',
          }}
        />
      </TouchableOpacity>
      <View style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
        <Text style={styles.userInfoText}>Welcome</Text>
        <Text style={styles.userInfoText}>
          {info?.display_name && info.display_name.length > 0
            ? info.display_name
            : info?.user_login}
        </Text>
        <Text style={styles.userInfoText}>#{info?.mbnum}</Text>
        <View style={{}}>
          <TouchableOpacity
            onPress={() => {
              NavigationService.push('Root', {
                screen: 'MyAccountTab',
              });
            }}
            style={{
              paddingHorizontal: 10,
              paddingVertical: 5,
              // backgroundColor: STYLE_VARS.kccBgGreen,
              borderRadius: 6,
              maxWidth: width / 2,
            }}
          >
            <Text
              style={{
                textAlign: 'left',
                fontFamily: FONTS.IowanOldStyleBTRoman,
                fontSize: 16,
                color: COLORS.GREEN,
                textTransform: 'uppercase',
              }}
            >
              {info?.member_type}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
      <TouchableOpacity
        style={{
          position: 'absolute',
          right: 0,
          top: 0,
          marginTop: 20,
        }}
      >
        <Image
          source={
            IS_WEB
              ? addBase64Prefix(close_icon)
              : require('../../../assets/close-icon.png')
          }
          style={{
            width: 22,
            height: 22,
            tintColor: STYLE_VARS.primaryColor,
          }}
          onPress={() => {
            NavigationService.goBack();
          }}
        />
      </TouchableOpacity>
    </View>
  );
};

export default UserMenu;

const styles = StyleSheet.create({
  wrapper: {
    flexDirection: 'row',
    paddingVertical: 20,
    alignItems: 'center',
  },
  userInfoText: {
    fontSize: 18,
    fontFamily: FONTS.IowanOldStyleBTRoman,
    color: STYLE_VARS.textColor,
    textAlign: 'center',
    textTransform: 'uppercase',
  },
});
